import React from "react";
import { Link } from "react-router-dom";   // ← IMPORTANTE
import ChatMockup from "./ChatMockup";

const Hero: React.FC = () => {
  return (
    <section className="relative w-full min-h-[95vh] flex items-center bg-[#0D1220] overflow-hidden pt-20 lg:pt-0">

      {/* Background Effects */}
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-[-10%] left-[-10%] w-[400px] h-[400px] bg-mira-accent/20 rounded-full blur-[120px] opacity-60"></div>
        <div className="absolute bottom-[-10%] right-[-10%] w-[500px] h-[500px] bg-blue-500/10 rounded-full blur-[120px] opacity-50"></div>
        <div className="absolute inset-0 bg-[linear-gradient(rgba(255,255,255,0.03)_1px,transparent_1px),linear-gradient(90deg,rgba(255,255,255,0.03)_1px,transparent_1px)] bg-[size:40px_40px] opacity-40"></div>
      </div>

      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-10 w-full relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-12 items-center">

          {/* LEFT COLUMN */}
          <div className="flex flex-col items-start space-y-8 animate-fade-in">

            {/* Badge */}
            <div className="flex items-center gap-2 px-4 py-1.5 rounded-full bg-mira-accent/10 border border-mira-accent/30 backdrop-blur-md">
              <span className="relative flex h-2.5 w-2.5">
                <span className="absolute inline-flex h-full w-full rounded-full bg-mira-accent opacity-75 animate-ping"></span>
                <span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-mira-accent"></span>
              </span>
              <span className="text-xs font-bold text-mira-accent tracking-[.15em] uppercase">
                Tu negocio 24/7
              </span>
            </div>

            {/* Title */}
            <h1 className="text-4xl sm:text-5xl md:text-6xl xl:text-7xl font-extrabold leading-tight text-white">
              Automatizamos <br className="hidden sm:block" />
              tu negocio con{" "}
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-mira-accent to-cyan-300 drop-shadow-lg">
                IA
              </span>
            </h1>

            {/* Subtitle */}
            <p className="text-lg text-gray-400 max-w-xl leading-relaxed border-l-2 border-mira-accent/20 pl-4">
              Chatbots inteligentes y flujos automatizados que responden al instante, 
              agendan citas y convierten visitantes en clientes — incluso mientras duermes.
            </p>

            {/* CTA BUTTONS */}
            <div className="flex flex-col sm:flex-row gap-4 pt-3">

              {/* CTA 1 — FIXED */}
              <Link
                to="/contacto"
                className="relative px-8 py-4 bg-mira-accent text-white font-bold rounded-xl overflow-hidden hover:shadow-[0_0_30px_rgba(26,140,255,0.4)] transition-all"
              >
                <span className="relative z-10 flex items-center gap-2">
                  Automatizar mi negocio
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="w-5 h-5"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M5 12h14" />
                    <path d="M12 5l7 7-7 7" />
                  </svg>
                </span>

                <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent translate-x-[-150%] hover:translate-x-[150%] transition-transform duration-1000"></div>
              </Link>

              {/* CTA 2 — NOW ALSO TO CONTACTO */}
              <Link
                to="/contacto"
                className="px-8 py-4 bg-white/5 border border-white/10 backdrop-blur-sm text-gray-300 font-semibold rounded-xl hover:bg-white/10 hover:text-white transition-all flex items-center gap-2"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="w-5 h-5"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <polygon points="5 3 19 12 5 21 5 3" />
                </svg>
                Ver cómo funciona
              </Link>
            </div>

            {/* Indicators */}
            <div className="pt-6">
              <div className="flex flex-wrap gap-4">
                {[
                  "Empresas en México, USA y LATAM",
                  "Atención 24/7 garantizada",
                  "Integración con API oficial de Meta",
                ].map((text, i) => (
                  <div key={i} className="flex items-center gap-2">
                    <div className="p-1 rounded-full bg-mira-accent/10 border border-mira-accent/20">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="w-3.5 h-3.5 text-mira-accent"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <path d="M9 12l2 2l4 -4" />
                      </svg>
                    </div>
                    <span className="text-sm text-gray-400">{text}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* RIGHT COLUMN */}
          <div className="flex flex-col items-center lg:items-end mt-12 lg:mt-0 relative">
            <div className="absolute top-1/2 -translate-y-1/2 w-[280px] h-[520px] bg-mira-accent/10 blur-[80px] rounded-full -z-10"></div>
            <div className="w-full max-w-sm transform transition-all duration-700 hover:scale-[1.02]">
              <ChatMockup />
            </div>
            <div className="mt-6 bg-[#131B2E]/80 backdrop-blur-md border border-gray-700/40 p-4 rounded-xl max-w-[300px] shadow-lg">
              <p className="text-sm text-gray-300 leading-snug">
                Ejemplo real del flujo que instalamos en clínicas, consultorios y negocios.
              </p>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default Hero;
